import type { ShengJiPublicState } from "../../../../shared/games/shengji.js";
import { TrumpBadge } from "../../components/TrumpBadge.js";

export function TrumpPanel({ state }: { state: ShengJiPublicState }) {
  const { trumpRank, trumpSuit } = state;
  return (
    <TrumpBadge
      suit={trumpSuit ?? null}
      rank={trumpRank}
      suitLabel={!trumpSuit ? "No trump" : undefined}
    />
  );
}
